import Axios from "axios";
import React, { Fragment, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";
import moveImage from "../../../../assets/images/move.jpg";
import { useNotification } from "../../../../contexts/NotificationContext";

export const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { notify } = useNotification();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateEmail(email)) {
      notify(t('auth.forgotPassword.invalidEmailWarning'), {
        type: "warning",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/Auth/ForgotPassword`,
        { email: email }
      );

      if (res.status === 200) {
        setEmailSent(true);
        notify(
          t('auth.forgotPassword.emailSentNotification'),
          { type: "success" }
        );
      } else {
        notify(t('auth.forgotPassword.requestError'), { type: "warning" });
      }
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? t('auth.forgotPassword.emailNotFoundError')
          : err.response?.data?.message || t('common.unknownError');
      notify(errorMessage, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="auth-wrapper">
        <div className="auth-content subscribe">
          <div className="card">
            <div className="row no-gutters">
              <div
                className="col-md-4 col-lg-6 d-none d-md-flex d-lg-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#24bdc1" }}
              >
                <img src={moveImage} alt="Move logo" className="img-fluid" />
              </div>
              <div className="col-md-8 col-lg-6">
                <div className="card-body text-center">
                  <div className="row justify-content-center">
                    <div className="col-sm-10">
                      {!emailSent ? (
                        <Form onSubmit={handleSubmit}>
                          <h3 className="mb-4">{t('auth.forgotPassword.pageTitle')}</h3>
                          <p className="text-muted mb-4">
                            {t('auth.forgotPassword.description')}
                          </p>
                          <div className="input-group mb-4">
                            <input
                              type="email"
                              className="form-control"
                              placeholder={t('auth.forgotPassword.emailPlaceholder')}
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              disabled={loading}
                            />
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary shadow-2 mb-4"
                            disabled={loading || !email}
                          >
                            {loading ? (
                              <ClipLoader size={20} color={"#ffffff"} />
                            ) : (
                              t('auth.forgotPassword.submitButton')
                            )}
                          </button>
                          <p className="mb-2 text-muted">
                            <Link to="/">{t('auth.forgotPassword.backToLogin')}</Link>
                          </p>
                        </Form>
                      ) : (
                        <div>
                          <h3 className="mb-4 text-success">{t('auth.forgotPassword.successTitle')}</h3>
                          <p className="text-muted mb-4"
                            dangerouslySetInnerHTML={{ __html: t('auth.forgotPassword.successMessage', { email }) }}
                          />
                          <p className="text-muted mb-4">
                            {t('auth.forgotPassword.successDescription')}
                          </p>
                          <button
                            onClick={() => navigate("/")}
                            className="btn btn-primary shadow-2 mb-4"
                          >
                            {t('auth.forgotPassword.backToLogin')}
                          </button>
                          <p className="mb-2 text-muted">
                            <span
                              style={{ cursor: "pointer", color: "#007bff" }}
                              onClick={() => {
                                setEmailSent(false);
                                setEmail("");
                              }}
                            >
                              {t('auth.forgotPassword.retryLink')}
                            </span>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
